export const JS_SEGMENT_TYPES = {
  TEMPORARY: "TEMPORARY",
  PERMANENT: "PERMANENT"
}
export const REPORT_TYPES = [
  {label: "Competition Detailed Sales" , value: "COMPETITION_DETAILED_SALES" },
  {label: "Competition Benchmark" , value: "COMPETITION_BENCHMARK" },
]
